import Header from '@/components/common/Header'
import pagePath from '@/utils/pagePath'
import styled from '@emotion/styled'
import { Button, Flex, Text, Title } from '@collable/ui'
import { Link } from 'react-router'

const ChannelManagePage = () => {
  return (
    <Container direction="column" gap={80} alignItems="center">
      <Header />
      <Content direction="column" gap={40}>
        <Flex direction="column" alignItems="center" gap={12}>
          <Title size="subTitle1" fontWeight="bold" as="h1">
            크리에이터 채널 등록하기
          </Title>
          <Text size="body2" color="labelAssistive">
            내 채널을 인증하고 콜라블에서 광고 제의 받아보세요
          </Text>
        </Flex>
        <Link to={pagePath.selectVerifyMethod}>
          <Button size="large" kind="solid" color="primary" width="100%">
            내 채널 등록하기
          </Button>
        </Link>
      </Content>
    </Container>
  )
}

export default ChannelManagePage

const Container = styled(Flex)`
  min-width: 100vh;
  min-height: 100vh;
`

const Content = styled(Flex)`
  width: 600px;
  padding: 48px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.line.lineNeutral};
  background-color: ${({ theme }) => theme.fill.fillAssistive};
`
